import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9f9;
  padding: 24px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 640px;
  padding: 48px 56px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`;

export const Description = styled.p`
  margin-top: 20px;
  color: #68737d;
  font-size: 16px;
  line-height: 1.6;
`;

export const Hint = styled.div`
  margin-top: 32px;
  padding: 16px 20px;
  background-color: #edf7ff;
  border-left: 4px solid #1f73b7;
  border-radius: 4px;
  color: #1f73b7;
  font-size: 15px;
  line-height: 1.5;
`;
